// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;Our soul has escaped<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;as a bird from the snare of the fowler;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the snare is broken and we are delivered.<br> </p> </div></div>";
// Exports
module.exports = code;